export default {
  methods: {
    getDomain() {
      if (window.location.host.includes("allefolders")) {
        return "allefolders";
      } else if (window.location.host.includes("promopromo")) {
        return "promopromo";
      } else if (window.location.host.includes("myshopi")) {
        return "myshopi";
      }
      return "allefolders";
    }
  }
};
